<script>
    import NotificationsDialog from "./NotificationsDialog.svelte";
    import { onMount } from "svelte";
    import { NotificationService } from "../../services/NotificationService";
    import { clickOutside } from "../../utils/clickOutside.js";
    import SVGIcon from "../SVGIcon.svelte";

    let unreadNotificationsCount = 0;
    let notifications = [];

    let dialogOpened = false;
    let notificationsLoading = false;
    let hasMoreNotifications = true;

    const paginationCount = 20;

    onMount(async () => {
        unreadNotificationsCount =
            await NotificationService.getUnreadNotificationsCount();
    });

    function toggleDialog() {
        dialogOpened = !dialogOpened;

        if (dialogOpened) loadNotifications();
    }

    async function loadNotifications() {
        if (notificationsLoading) return;

        notificationsLoading = true;
        notifications =
            await NotificationService.getNotifications(paginationCount);
        notificationsLoading = false;

        //mark as read
        if (notifications.length > 0) {
            unreadNotificationsCount = 0;
            let lastReadDate = notifications[0].createdOn;

            NotificationService.markNotificationsRead(lastReadDate);
        }

        if (notifications.length > paginationCount) hasMoreNotifications = true;
    }

    async function loadMoreNotifications() {
        if (notificationsLoading) return;

        let oldestRead =
            notifications.length == 0
                ? null
                : notifications[notifications.length - 1].createdOn;

        notificationsLoading = true;
        let newNotifications = await NotificationService.getNotifications(
            paginationCount,
            oldestRead,
        );
        notificationsLoading = false;

        notifications = [...notifications, ...newNotifications];

        if (newNotifications.length < paginationCount)
            hasMoreNotifications = false;
    }
</script>

<div
    class="notifications-tray"
    use:clickOutside
    on:click_outside={() => (dialogOpened = false)}
>
    <button class="notifications-icon" on:click={toggleDialog}>
        {#if unreadNotificationsCount > 0}
            <button class="unread-count">
                {unreadNotificationsCount}
            </button>
        {/if}

        <SVGIcon name="bell" size="20" />
    </button>

    {#if dialogOpened}
        <NotificationsDialog
            {notifications}
            {hasMoreNotifications}
            {notificationsLoading}
            on:loadMore={loadMoreNotifications}
        />
    {/if}
</div>

<style>
    .notifications-tray {
        @apply relative;
    }

    .notifications-icon {
        @apply relative self-baseline p-1 text-white;
    }

    .unread-count {
        @apply absolute right-0 top-0 rounded-full bg-pink-500 px-1 text-2xs font-bold text-white;
    }
</style>
